import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import * as d3 from "d3";

@Component({
  selector: "scaffold-course-archive-progress-donut-chart",
  templateUrl: "./course-archive-progress-donut-chart.component.html",
  styleUrls: [
    "./course-archive-progress-donut-chart.component.scss",
    "../course-archive-progress.component.scss",
  ],
})
export class CourseArchiveProgressDonutChartComponent implements OnChanges {
  @ViewChild("chart") private chartContainer: ElementRef;
  @Input() data;
  @Input() isLoading;
  @Input() hasError;
  @Input() field = "";

  get total() {
    return this?.data?.total || 100;
  }

  get stat() {
    return this?.data?.[this?.field] || 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.createChart();
  }

  ngAfterViewInit() {
    this.createChart();
  }

  setLoadingView() {}
  createChart() {
    if (this?.chartContainer?.nativeElement)
      d3.select(this?.chartContainer?.nativeElement).select("svg").remove();
    let element = this?.chartContainer?.nativeElement;
    let data = this.isLoading
      ? [0.5, 0.5]
      : [this.stat, this.total - this.stat];
    let pie = d3.pie().sort(null)(data);
    let width = 100;
    let height = 100;
    let outerRadius = Math.min(width, height) / 2;
    let innerRadius = outerRadius / 1.3;

    let arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);

    let svg = d3
      .select(element)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    let path = svg
      .selectAll("path")
      .data(pie)
      .enter()
      .append("path")
      .attr("d", <any>arc)
      .attr("fill", (d, i) => (i === 0 ? "#fff" : "rgba(255, 255, 255, 0.3)"));

    if (this.isLoading) {
      path.style("animation", "spin 2s linear infinite");
    }
    path.style("transform-origin", "0% 0%");

    if (!this.isLoading) {
      this.hasError
        ? svg
            .append("text")
            .attr("text-anchor", "middle")
            .attr("dy", ".35em")
            .attr("fill", "white")
            .text(() => "!")
        : svg
            .append("text")
            .attr("text-anchor", "middle")
            .attr("dy", ".35em")
            .attr("fill", "white")
            .text(
              ((!this.stat ? 0 : this.stat / this.total) * 100).toFixed(1) + "%"
            );
    }
  }
}
